import { render, staticRenderFns } from "./FlexGroup.vue?vue&type=template&id=57ead838&scoped=true"
import script from "./FlexGroup.vue?vue&type=script&lang=ts"
export * from "./FlexGroup.vue?vue&type=script&lang=ts"
import style0 from "./FlexGroup.vue?vue&type=style&index=0&id=57ead838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ead838",
  null
  
)

export default component.exports